import {EventEmitter} from 'eventemitter3'

export const patientEvent = new EventEmitter()

export const patientEventTypes = {
    TABLE_CHANGE: 'TABLE_CHANGE',
    PATHWAY_CHANGE: 'PATHWAY_CHANGE',
    STATIC_LIST_CHANGE: 'STATIC_LIST_CHANGE',
    SUPPORT_TEAM_CHANGE: 'SUPPORT_TEAM_CHANGE',
}

export function getPatientEventKey(eventType) {
    if (!eventType) {
        return ''
    }

    switch (eventType) {
        case patientEventTypes.TABLE_CHANGE:
            return `PATIENT_TABLE_CHANGE`
        case patientEventTypes.PATHWAY_CHANGE:
            return `PATIENT_PATHWAY_CHANGE`
        case patientEventTypes.STATIC_LIST_CHANGE:
            return `PATIENT_STATIC_LIST_CHANGE`
        case patientEventTypes.SUPPORT_TEAM_CHANGE:
            return `PATIENT_SUPPORT_TEAM_CHANGE`
        default:
            return ''
    }
}

//#region TABLE CHANGE
export function onPatientTableChangeListener(
    eventType = patientEventTypes.TABLE_CHANGE,
    data,
) {
    patientEvent.emit(getPatientEventKey(eventType), data)
}

export function onPatientTableChangeRemoveListener(
    eventType = patientEventTypes.TABLE_CHANGE,
) {
    patientEvent.removeListener(getPatientEventKey(eventType))
}
//#endregion

//#region USER PATHWAY CHANGE
export function onPatientPathwayChangeListener(
    eventType = patientEventTypes.PATHWAY_CHANGE,
    data,
) {
    patientEvent.emit(getPatientEventKey(eventType), data)
}

export function onPatientPathwayChangeRemoveListener(
    eventType = patientEventTypes.PATHWAY_CHANGE,
) {
    patientEvent.removeListener(getPatientEventKey(eventType))
}
//#endregion

//#region USER STATIC_LIST CHANGE
export function onPatientStaticListChangeListener(
    eventType = patientEventTypes.STATIC_LIST_CHANGE,
    data,
) {
    patientEvent.emit(getPatientEventKey(eventType), data)
}

export function onPatientStaticListChangeRemoveListener(
    eventType = patientEventTypes.STATIC_LIST_CHANGE,
) {
    patientEvent.removeListener(getPatientEventKey(eventType))
}
//#endregion

//#region USER SUPPORT TEAM CHANGE
export function onPatientSupportTeamChangeListener(
    eventType = patientEventTypes.SUPPORT_TEAM_CHANGE,
    data,
) {
    patientEvent.emit(getPatientEventKey(eventType), data)
}

export function onPatientSupportTeamChangeRemoveListener(
    eventType = patientEventTypes.SUPPORT_TEAM_CHANGE,
) {
    patientEvent.removeListener(getPatientEventKey(eventType))
}
//#endregion
